export const NEIGHBORHOODS: string[] = [
  'Janaina',
  'Lagoa Cortada',
  'Village Dunas Norte',
  'Village Dunas',
  'Brilhamar',
  'Santa Fé',
  'Turimar',
  'Centro',
  'Jardim Ultramar',
  'Itapuã',
  'Lagoa de Fora',
  'Rua Nova',
  'Figueirinha',
  'Onda Azul',
  'Sul Mar',
  'Fernão Capelo',
  'Areias Claras',
  'Sombrio (Centro)'
];
